<script lang="ts" setup>
import mockupImg from '@/assets/mockup.webp'
import adamVideo from '@/assets/quote/adam.mp4'
import gitaraVideo from '@/assets/quote/gitara.mp4'
import kamaVideo from '@/assets/quote/kama.mp4'
</script>

<template>
  <v-container
    class="d-flex flex-column ga-10"
    :max-width="780"
  >
    <v-img
      :src="mockupImg"
      width="100%"
      class="mx-auto"
    />
    <div
      class="text-h3 text-center mx-auto"
      :style="{
        background: 'linear-gradient(69deg, rgb(var(--v-theme-primary-900)) 20.89%, rgb(var(--v-theme-primary-300)) 83.41%)',
        backgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }"
    >
      Śpiewajcie Panu pieśń nową<br>
      grajcie Mu pięknie z radością!
    </div>
    <div class="d-flex flex-row">
      <div class="d-flex flex-column align-center w-100">
        <csm-ui-video
          class="flex-grow-0"
          :aspect-ratio="1"
          :max-width="100"
          width="100%"
          rounded="circle"
          :url="{ 'video/mp4': gitaraVideo }"
        />
      </div>
      <div class="d-flex flex-column align-center w-100">
        <csm-ui-video
          class="flex-grow-0 mt-16"
          :aspect-ratio="1"
          :max-width="180"
          width="100%"
          rounded="circle"
          :url="{ 'video/mp4': kamaVideo }"
        />
      </div>
      <div class="d-flex flex-column align-center w-100">
        <csm-ui-video
          class="flex-grow-0 mt-2"
          :aspect-ratio="1"
          :max-width="124"
          width="100%"
          rounded="circle"
          :url="{ 'video/mp4': adamVideo }"
        />
      </div>
    </div>
  </v-container>
</template>
